import React, {FC, PropsWithChildren} from 'react';

export const ValidationError: FC<PropsWithChildren> = ({children}) => (children ? <h3 className="text-trak-red">{children}</h3> : null);
